import { createSlice } from "@reduxjs/toolkit";
import {
  Board,
  Language,
  Price,
  PriceOffers,
  PricesState,
} from "../types/index.js";
import { fetch, keys } from "../utils/utils.js";
import { showAlert } from "./alerts.js";
import { createAppAsyncThunk } from "./utils.js";

const sliceName = "prices";

const initialState: PricesState = { boards: [], offers: {}, byId: {} };

export const getPrices = createAppAsyncThunk(
  `${sliceName}/getPrices`,
  async (
    { siteId, languageId }: { siteId: string; languageId: Language },
    { dispatch },
  ) => {
    try {
      const data = await fetch({ dispatch, languageId, authorize: false })
        .get(`sites/${siteId}/prices`)
        .json<Price[]>();
      return data;
    } catch (error) {
      dispatch(
        showAlert("Beim Laden der Preis-Daten ist ein Fehler aufgetreten!"),
      );
      throw error;
    }
  },
  {
    condition: (_arg, { getState }) => {
      const loadState = getState().loadStates.prices;
      return loadState === "unloaded" || loadState === undefined;
    },
  },
);

const getBoards = (prices: Price[]): Board[] => {
  const byBoards = prices.reduce<{ [board: number]: 1 }>((byBoards, price) => {
    keys(price.boards).forEach((board: Board) => {
      if (price.boards[board] > 0) {
        byBoards[board] = 1;
      }
    });
    return byBoards;
  }, {});

  return keys(byBoards).map<Board>((board) => <Board>+board);
};

const getOffers = (state: PriceOffers, prices: Price[]): PriceOffers =>
  prices.reduce<PriceOffers>(
    (priceOffers, { offerId, label }) => ({
      ...priceOffers,
      [offerId]: { offerId, label },
    }),
    state,
  );

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPrices.fulfilled, (state, action) => {
      state.boards = getBoards(action.payload);
      state.offers = getOffers(initialState.offers, action.payload);
    });
  },
});

export default slice.reducer;
